import { Box, Flex, Icon, Text } from "@chakra-ui/react";

export interface StatCardProps {
  label: string;
  value: number;
  bg: string;
  icon: React.ElementType;
  isLoading?: boolean;
  isActive?: boolean;
  onClick?: () => void;
}

export const StatCard = ({ label, value, bg, icon, isLoading, isActive, onClick }: StatCardProps) => (
  <Box position="relative" borderRadius="xl" overflow="hidden">
    <Flex
      bg={bg} borderRadius="xl" p={{ base: 3, md: 5 }} color="white" align="center" gap={{ base: 2, md: 4 }}
      cursor={onClick ? "pointer" : undefined}
      boxShadow={isActive ? "0 0 0 2px white" : undefined}
      opacity={onClick && isActive === false ? 0.6 : 1}
      transition="opacity 0.15s, box-shadow 0.15s"
      _hover={onClick ? { opacity: 1 } : undefined}
      onClick={onClick}
    >
      <Flex
        align="center"
        justify="center"
        w={{ base: "36px", md: "48px" }}
        h={{ base: "36px", md: "48px" }}
        borderRadius="lg"
        bg="whiteAlpha.200"
        flexShrink={0}
        visibility={isLoading ? "hidden" : "visible"}
      >
        <Icon as={icon} boxSize={{ base: 4, md: 5 }} />
      </Flex>
      <Box visibility={isLoading ? "hidden" : "visible"} minW={0}>
        <Text fontSize={{ base: "2xl", md: "3xl" }} fontWeight="700" lineHeight={1} color="white">
          {value}
        </Text>
        <Text
          fontSize={{ base: "9px", md: "xs" }}
          mt={1}
          opacity={0.85}
          textTransform="uppercase"
          letterSpacing={{ base: "normal", md: "wider" }}
          color="white"
          noOfLines={2}
        >
          {label}
        </Text>
      </Box>
    </Flex>
    {isLoading && (
      <Box
        position="absolute"
        inset={0}
        sx={{
          "@keyframes shimmer": {
            "0%":   { backgroundPosition: "-200% center" },
            "100%": { backgroundPosition:  "200% center" },
          },
          background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.22) 50%, transparent 100%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.4s infinite linear",
        }}
      />
    )}
  </Box>
);
